/* eslint-disable no-underscore-dangle */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable no-param-reassign */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-unused-expressions */
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';

import {
  Grid,
  IconButton,
  Snackbar,
  TextField,
  Tooltip,
  Typography
} from '@material-ui/core';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { Alert, Autocomplete, Pagination } from '@material-ui/lab';
import axios from 'axios';
import { connect, useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { bindActionCreators } from 'redux';

import CommonAlert from 'components/CommonAlert/CommonAlert';
import ConfirmModal from 'components/Dialogs/ConfirmModal/ConfirmModal';
import ItemsPerPage from 'components/ItemsPerPage';
import PageTitleAndFilter from 'components/PageTitleAndFilter';
import TitleHead from 'components/TitleHead';
import OverlayLabelPrintFooter from 'containers/footerMobile/labelPrintFooter';
import Layout from 'containers/layouts/layout';
import EngineIcon from 'images/icons/configsAndSetups/configLightBlueBgWhiteRoundedLightBlueBorder.svg';
import EngineIconDesktop from 'images/icons/configsAndSetups/configWhiteBgBlue.svg';
import DownloadIcon from 'images/icons/downloadUpload/download.svg';
import QrCodeIcon from 'images/icons/downloadUpload/qrCodeLightBlueNoBgRoundedLightBlueBordered.svg';
import UploadIcon from 'images/icons/downloadUpload/upload.svg';
import TemplateIcon from 'images/icons/files/templateIcon.svg';
import AddIcon from 'images/icons/signals/addsAndCreates/add.svg';
import { InputFile } from 'pages/quotesUpload/style';
import axiosInstanceCatalog from 'services/middlewares/apis/catalog_validate';
import * as ProductsActions from 'store/actions/products';
import { changeFilter, clearFilter } from 'store/reducers/productsFilterSlice';
import { Container, GlobalStyle } from 'styles/general';
import Environment from 'utils/environments';
import {
  getFilterOptions,
  handleFilterOptions,
  handleMultipleFilters
} from 'utils/handleFilterActions';
import DesktopProductsTable from './components/DesktopProductsTable';
import MobileProductCards from './components/MobileProductCards';
import ValidityFilter from './components/ValidityFilter';
import LabelPrintConfigDialog from './dialogs/LabelPrintConfigDialog';
import PrintParametersDialog from './dialogs/PrintParametersDialog';
import PrintQrCodeScannerDialog from './dialogs/PrintQrCodeScannerDialog';
import ProductDialog from './dialogs/ProductDialog';
import StockExtractDialog from './dialogs/StockExtractDialog';

import convertToBase64 from 'utils/convertToBase64';
import { setSubGroupsAndStores } from 'utils/setSubGroupsAndStores';
import RestaurantGroupSelector from './components/RestaurantGroupSelector.jsx';
import getOptions from 'services/getOptions';
import { PaginationWrapper } from './styles';

const environments = Environment(process.env.REACT_APP_ENV);

const PREV_LABEL_STATUS_MODEL = {
  ON_DATE: 'ON_DATE',
  VALID: 'VALID',
  EXPIRED: 'EXPIRED'
};

function Products({ userInfo }) {
  const inputRef = useRef();
  const dispatch = useDispatch();
  const { id: paramsID, productId } = useParams();
  const history = useHistory();
  const prevLabelStatus =
    PREV_LABEL_STATUS_MODEL[history?.location?.state?.labelStatus] || null;

  const userLocal = JSON.parse(localStorage.getItem('companies'));
  const isMobileScreen = useMediaQuery('(max-width: 866px)');
  const isSmallTablet = useMediaQuery('(max-width: 602px)');
  const isPhoneScreen = useMediaQuery('(max-width: 576px)');
  const profile = userInfo?.profile[0][0]?.name;
  const isAdminPage = profile === 'admin';
  const isLabelAdmin = profile === 'admin_label';
  const isLabelManager = profile === 'manager_label';
  const isLabelUser = profile === 'label';
  const currentUserId = isLabelAdmin ? userLocal?.labelId : paramsID;
  const labelManagerHasAllPermissions =
    isLabelManager && !userInfo?.labelOnlyRestaurants;
  const storedProductsFilter = useSelector(
    (currState) => currState.productsFilter.filters
  );
  const shouldUseStoredFilters = useMemo(
    () => storedProductsFilter,
    [storedProductsFilter]
  );

  const labelsVersion = useSelector((s) => s.labels?.version || 0);

  const [callSettings, setCallSettings] = useState({
    getId: paramsID,
    mainLoading: false,
    page: 1,
    totalPages: 0,
    size: 100,
    filters: shouldUseStoredFilters ? storedProductsFilter : [],
    numberOfElements: 0,
    totalElements: 0
  });

  const [userGroups, setUserGroups] = useState({
    groups: [
      {
        subGroups: [
          {
            stores: [{}]
          }
        ]
      }
    ]
  });
  const [restaurantGroups, setRestaurantGroups] = useState([
    userInfo.companies.groups[0]
  ]);
  const [restaurantSubGroups, setRestaurantSubGroups] = useState([]);
  const [restaurantStores, setRestaurantStores] = useState([]);
  const [flagOptions, setFlagOptions] = useState([]);
  const [flags, setFlags] = useState([]);
  const [invalidFields, setInvalidFields] = useState({
    stores: false
  });

  const {
    getId,
    mainLoading,
    page,
    size,
    totalPages,
    numberOfElements,
    totalElements
  } = callSettings;
  const [filtersChanged, setFiltersChanged] = useState(
    prevLabelStatus
      ? [
          {
            labelStatus: prevLabelStatus,
            param: 'labelStatus',
            textValue: prevLabelStatus,
            urlParam: `labelStatus=${prevLabelStatus}`,
            value: prevLabelStatus
          }
        ]
      : callSettings?.filters
  );
  const cancelTokenSource = axios.CancelToken.source();
  const [validityFilterInfos, setValidityFilterInfos] = useState();
  const [modalSettings, setModalSettings] = useState([
    {
      id: 1,
      name: 'productDialog',
      open: false
    },
    {
      id: 2,
      name: 'labelPrintConfigDialog',
      open: false,
      product: null
    },
    {
      id: 3,
      name: 'printQrCodeScannerDialog',
      open: false
    },
    {
      id: 4,
      name: 'stockExtractDialog',
      open: false
    },
    {
      id: 5,
      name: 'confirmDialog',
      open: false,
      title: '',
      content: ''
    },
    {
      id: 6,
      name: 'confirmDeleteDialog',
      open: false,
      title: '',
      content: ''
    },
    {
      id: 7,
      name: 'printParametersDialog',
      open: false
    },
    {
      id: 8,
      name: 'importSpreadSheetConfigDialog',
      open: false,
      title: '',
      content: ''
    }
  ]);
  const [products, setProducts] = useState([]);
  const [message, setMessage] = useState({
    description: '',
    status: ''
  });
  const [parameters, setParameters] = useState(null);
  const [toastProps, setToastProps] = useState({});
  const [toastOpen, setToastOpen] = useState(false);
  const [filterOpen, setFilterOpen] = useState(true);
  const isGroupManage = getId?.includes(',');

  const [filterFields, setFilterFields] = useState([
    [
      {
        label: 'Produto',
        filterName: 'productDescription',
        filterNameSecond: 'productId',
        placeHolder: 'Selecione...',
        type: 'autoComplete',
        key: 'products',
        optionReference: 'description',
        urlPath: `${environments.catalog}/products`,
        options: [],
        size: 'medium',
        searchByTermMode: true,
        storedValue:
          (shouldUseStoredFilters &&
            storedProductsFilter.find(
              (filter) => filter.filterName === 'productDescription'
            )?.productDescription) ||
          storedProductsFilter.find(
            (filter) => filter.filterName === 'productId'
          )?.textValue,
        marginRight: '25px'
      },
      {
        label: 'Categoria',
        filterName: 'categoryDescription',
        placeHolder: 'Selecione...',
        type: 'newTreeSelector',
        urlPath: `${environments.catalog}/categories`,
        key: 'categoryDescription',
        page: 1,
        optionReference: 'description',
        options: [],
        size: 'medium_to_plus',
        storedValue:
          shouldUseStoredFilters &&
          storedProductsFilter.find(
            (filter) => filter.filterName === 'category'
          )?.textValue,
        marginRight: '25px'
      },
      ...(isLabelAdmin
        ? [
            {
              label: 'Marca',
              filterName: 'flagDescription',
              filterNameSecond: 'flagId',
              placeHolder: 'Selecione...',
              type: 'autoComplete',
              key: 'flags',
              optionReference: 'description',
              urlPath: `${environments.catalog}/flags`,
              options: [],
              size: 'medium',
              searchByTermMode: true,
              storedValue:
                shouldUseStoredFilters &&
                storedProductsFilter.find(
                  (filter) => filter.filterName === 'flagId'
                )?.textValue,
              marginRight: '25px'
            }
          ]
        : [])
    ]
  ]);

  const [originalFlags, setOriginalFlags] = useState([]);
  const allowedFlagOptions = flagOptions.filter((option) =>
    originalFlags.some((flag) => flag.id === option.id)
  );

  const config = {
    headers: {
      User: `${userLocal?.user}`
    }
  };

  const downloadSpreadsheet = () => {
    const url = `${environments.catalog}/labels/spreadsheet/download`;

    const link = document.createElement('a');
    link.href = url;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const exportSpreadsheet = () => {
    const url = `${environments.catalog}/printer/products/spreadsheet/export?originId=${currentUserId}`;

    const link = document.createElement('a');
    link.href = url;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const uploadSpreadsheet = async (inputRef, event) => {
    const endpoint = `${environments.catalog}/labels/spreadsheet/import`;
    const spreadsheetBase64 = await convertToBase64(event.target.files[0]);
    const pluckIds = (arr) => arr.map((obj) => obj.id);

    const buildStores = (subGroup) => {
      const stores = subGroup.stores.filter((store) =>
        pluckIds(restaurantStores).includes(store.id)
      );

      return stores.map((store) => ({
        id: store.id,
        name: store.name
      }));
    };

    const buildSubGroups = (group) => {
      const subGroups = group.subGroups.filter((subGroup) =>
        pluckIds(restaurantSubGroups).includes(subGroup.id)
      );

      return subGroups.map((subGroup) => ({
        id: subGroup.id,
        name: subGroup.name,
        stores: buildStores(subGroup)
      }));
    };

    const body = {
      groups: userGroups?.groups,
      flags: flags,
      restaurantId: currentUserId,
      user: userInfo.user,
      spreadsheet: spreadsheetBase64
    };

    axios
      .post(endpoint, body)
      .then(() => {
        setToastProps({
          severity: 'success',
          message:
            'Sua planilha foi importada. O processamento pode levar algum tempo. Volte em breve!'
        });

        setToastOpen(true);
        setFlags([]);
      })
      .catch((err) => {
        if (err?.response?.data?.type == 'Incorrect format') {
          setToastProps({
            severity: 'error',
            message:
              'A planilha não está no formato correto para ser lida. As colunas necessárias para o sucesso da importação podem estar faltando.'
          });
        } else if (err?.response?.data?.type == 'Invalid restaurant') {
          setToastProps({
            severity: 'error',
            message:
              'A planilha que está sendo importada pertence a outro restaurante.'
          });
        } else if (err?.response?.data?.type === 'Missing information') {
          const lineErrors = err.response.data.lineErrors || [];
          const lines = lineErrors.toString().replaceAll(',', ', ');

          setToastProps({
            severity: 'error',
            message: 'Faltam algumas informações obrigatórias no produto.',
            lineErrors: lines
          });
        } else {
          setToastProps({
            severity: 'error',
            message:
              'Não foi possível importar a planilha. Tente novamente mais tarde.'
          });
        }

        setToastOpen(true);
      });

    const { current: { value } = {} } = inputRef;

    if (value) {
      inputRef.current.value = null;
    }
  };

  const downloadSpreadsheetButton = () => (
    <Tooltip title="Baixar template da planilha de produtos" aria-label="add">
      <IconButton
        className="p0 mr3 ml10"
        color="primary"
        aria-label="add"
        component="span"
        onClick={() => {
          downloadSpreadsheet();
        }}
      >
        <img style={{ width: '25px' }} src={TemplateIcon} alt="TemplateIcon" />
      </IconButton>
    </Tooltip>
  );

  const exportSpreadsheetButton = () => (
    <Tooltip title="Baixar planilha de produtos" aria-label="export">
      <IconButton
        className="p0 mr10 ml10"
        color="primary"
        aria-label="export"
        component="span"
        onClick={exportSpreadsheet}
      >
        <img style={{ width: '25px' }} src={DownloadIcon} alt="DownloadIcon" />
      </IconButton>
    </Tooltip>
  );

  const uploadSpreadsheetButton = () => (
    <Tooltip title="Importar planilha de produtos" aria-label="add">
      <IconButton
        className="p0 cursorPointer"
        color="primary"
        aria-label="add"
        component="span"
        onClick={() => {
          setModalSettings(
            modalSettings.map((modal) =>
              modal.name === 'importSpreadSheetConfigDialog'
                ? {
                    ...modal,
                    open: true,
                    title: `Selecione as marcas`,
                    customClass: 'importSpreadSheetConfigDialog',
                    onClose: () =>
                      setModalSettings(
                        modalSettings.map((modal) =>
                          modal.name === 'importSpreadSheetConfigDialog'
                            ? {
                                ...modal,
                                open: false,
                                product: null,
                                customClass: '',
                                title: '',
                                content: '',
                                onConfirm: '',
                                onClose: ''
                              }
                            : modal
                        )
                      )
                  }
                : modal
            )
          );
        }}
      >
        <img
          className="cursorPointer"
          style={{ width: '25px' }}
          src={UploadIcon}
          alt="UploadIcon"
        />
      </IconButton>
    </Tooltip>
  );

  const handleCloseToast = (_, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setToastOpen(false);
  };

  const validateFields = () => {
    const isValid = restaurantStores?.length > 0;

    setInvalidFields((prev) => ({
      ...prev,
      stores: !isValid
    }));

    return isValid;
  };

  async function handleDelete(currentProduct) {
    if (!validateFields()) return;

    const groupId = userInfo?.companies?.groups?.length
      ? `&groupId=${userInfo?.companies?.groups[0]?.id}`
      : '';

    const baseUrl = `${environments.catalog}/printer/products`;
    const deleteUrl = `${baseUrl}/${currentProduct.id}?user=${
      userInfo?.user
    }&restaurantId=${currentUserId}&flagIds=${flags
      ?.map((el) => el?.id)
      .join(',')}${groupId}`;

    try {
      await axios.delete(deleteUrl, config);

      setMessage({
        description: 'Produto deletado com sucesso!',
        status: 'success'
      });

      getMainContent(page, size);
      setFlags([]);
      setOriginalFlags([]);

      getValidityFilterContent();

      setModalSettings(
        modalSettings.map((modal) =>
          modal.name === 'confirmDeleteDialog'
            ? {
                ...modal,
                open: false,
                product: null,
                title: '',
                onClose: ''
              }
            : modal
        )
      );
    } catch (error) {
      setMessage({
        description:
          error?.response?.data?.message || 'Erro ao deletar produto',
        status: 'error'
      });

      throw error;
    }
  }

  const clearFilterValues = (param) => {
    const FILTER_FIELDS = filterFields.map((filterLine, index) => {
      if (index === 0) {
        return filterLine.map((item) => {
          if (item?.filterName === param) {
            return {
              ...item,
              storedValue: ''
            };
          }

          return item;
        });
      }

      return filterLine;
    });

    setFilterFields(FILTER_FIELDS);
  };

  const handleFilter = useCallback(
    (param, value, filter, paramSecond) => {
      const hasFilterWithFirstName = filtersChanged?.some(
        (el) => el?.param === param
      );
      const hasFilterWithSecondName = filtersChanged?.some(
        (el) => el?.param === paramSecond
      );

      let formattedFilters = hasFilterWithSecondName
        ? filtersChanged?.filter((el) => el?.param !== paramSecond)
        : filtersChanged;

      if (!value) {
        clearFilterValues(param);
        dispatch(clearFilter());

        if (hasFilterWithFirstName || hasFilterWithSecondName) {
          formattedFilters = filtersChanged?.filter(
            (el) =>
              el?.param !== paramSecond &&
              el?.param !== param &&
              el?.param !== 'flagId'
          );
        }

        setFiltersChanged(formattedFilters);
        return;
      }

      cancelTokenSource.cancel();

      if (param === 'flagDescription') {
        const withoutFlag = formattedFilters.filter(
          (f) => f.param !== 'flagId' && f.param !== 'flagDescription'
        );

        if (typeof value === 'string') {
          const text = value.trim();
          const newFilters = [
            ...withoutFlag,
            {
              param: 'flagDescription',
              textValue: text,
              urlParam: text
                ? `flagDescription=${encodeURIComponent(text)}`
                : '',
              value: text
            }
          ];
          setFiltersChanged(newFilters);
          dispatch(
            changeFilter({
              param: 'flagDescription',
              value: text,
              textValue: text
            })
          );
          return;
        }

        const arr = Array.isArray(value) ? value : [value];
        const ids = arr
          .map((v) => v?.id)
          .filter(Boolean)
          .join(',');
        const text = arr
          .map((v) => v?.description ?? '')
          .filter(Boolean)
          .join(', ');

        const entry = ids
          ? {
              param: 'flagId',
              value: ids,
              textValue: text,
              urlParam: ids ? `flagId=${encodeURIComponent(ids)}` : ''
            }
          : {
              param: 'flagDescription',
              value: text,
              textValue: text,
              urlParam: text
                ? `flagDescription=${encodeURIComponent(text)}`
                : ''
            };

        const newFilters = [...withoutFlag, entry];
        setFiltersChanged(newFilters);
        dispatch(changeFilter(entry));
        return;
      }

      if (param !== 'labelStatus') {
        dispatch(
          changeFilter({
            param,
            value,
            textValue: filter?.title
          })
        );
      }

      handleFilterOptions(param, value, formattedFilters, setFiltersChanged);
    },
    [dispatch, filtersChanged]
  );

  const handleOrdinationFilter = (paramsAndValues) => {
    handleMultipleFilters(paramsAndValues, filtersChanged, setFiltersChanged);
  };

  const printLabel = async (product, isReprint = false) => {
    try {
      const response = await axios.post(
        `${environments.catalog}/printer/products/labels`,
        {
          ...(isReprint && { labelId: product?.id }),
          restaurantId: currentUserId,
          productId: isReprint ? product?.productId : product?.id,
          quantity: product?.quantity,
          numberOfLabels: product?.numberOfLabels,
          user: userInfo?.user
        },
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );

      getValidityFilterContent();

      setModalSettings(
        modalSettings.map((modal) =>
          modal.name === 'labelPrintConfigDialog'
            ? { ...modal, open: false, product: null }
            : modal
        )
      );

      setMessage({
        description: 'Solicitação de impressão enviada',
        status: 'success'
      });

      getMainContent(page, size, true);
      return response.data;
    } catch (error) {
      setMessage({
        description: 'Erro ao imprimir etiqueta',
        status: 'error'
      });
      throw error;
    }
  };

  // GET PRODUCTS
  const getMainContent = useCallback(
    (currPage, currSize, disableLoading = false) => {
      (async () => {
        setCallSettings((prevState) => ({
          ...prevState,
          mainLoading: !disableLoading
        }));

        let params = [];

        const paramsFromChanged = filtersChanged
          ?.filter((el) => el?.value && el?.urlParam)
          .map((f) => f.urlParam)
          .join('&');

        if (paramsFromChanged) {
          params = paramsFromChanged;
        } else if (
          // 2) fallback: filtros salvos (Redux)
          shouldUseStoredFilters &&
          shouldUseStoredFilters !== 'menuHeader' &&
          storedProductsFilter?.length
        ) {
          const parsedFilters = storedProductsFilter
            .map((filter) => {
              // nome do filtro
              const name = filter.filterName || filter.param || '';

              // IDs que SEMPRE devem permanecer numéricos na URL:
              const keepIds = ['flagId', 'productId', 'categoryId'];
              if (keepIds.includes(name)) {
                const val = filter[name] ?? filter.value;
                if (val) return `${name}=${encodeURIComponent(val)}&`;
              }

              // regra antiga — só para os demais IDs
              if (name?.toLowerCase().includes('id') && filter.textValue) {
                const newKey = name.replace(/Id/gi, 'Description');
                return `${newKey}=${encodeURIComponent(filter.textValue)}&`;
              }

              // fallback genérico
              const key = Object.keys(filter).find(
                (k) =>
                  !['filterName', 'textValue', 'param'].includes(k) && filter[k]
              );
              if (key) return `${key}=${encodeURIComponent(filter[key])}&`;

              return null;
            })
            .filter(Boolean)
            .join('');

          params = parsedFilters;
        } else {
          params = '';
        }
        try {
          const response = await axiosInstanceCatalog.get(
            `${environments.catalog}/printer/products?page=${currPage}&size=${currSize}&restaurantId=${currentUserId}&${params}`,
            { cancelToken: cancelTokenSource.token }
          );

          const productsResponse = await response.data;

          setProducts(productsResponse.content || []);
          setCallSettings((prevState) => ({
            ...prevState,
            totalPages: productsResponse.totalPages,
            mainLoading: false,
            totalElements: productsResponse.totalElements,
            numberOfElements: productsResponse.numberOfElements
          }));
        } catch (error) {
          if (axios.isCancel(error)) {
            console.log('Requisição cancelada:', error.message);
          } else {
            console.error('Erro na requisição:', error);
          }
        }
      })();
    },
    [
      shouldUseStoredFilters,
      currentUserId,
      storedProductsFilter,
      filtersChanged
    ]
  );

  const getValidityFilterContent = useCallback(() => {
    (async () => {
      setValidityFilterInfos({
        ...validityFilterInfos,
        loading: true
      });

      try {
        const response = await axiosInstanceCatalog.get(
          `${environments.catalog}/printer/products/labels?restaurantId=${currentUserId}`,
          { cancelToken: cancelTokenSource.token }
        );

        const validityValuesResponse = await response.data;

        setValidityFilterInfos({
          ...validityFilterInfos,
          content: validityValuesResponse || [],
          loading: false
        });
      } catch (error) {
        if (axios.isCancel(error)) {
          console.log('Requisição cancelada:', error.message);
        } else {
          console.error('Erro na requisição:', error);
        }
      }
    })();
  }, [currentUserId, products]);

  const getFilterhandle = (urlPath, label, key, optionReference) => {
    getFilterOptions(
      urlPath,
      label,
      key,
      filterFields,
      setFilterFields,
      optionReference,
      currentUserId,
      '',
      page
    );
  };

  async function fetchRestaurantsOfProduct(productId) {
    const response = await fetch(
      `${environments.catalog}/products/${productId}/groups`
    );
    const groups = await response.json();

    return groups;
  }

  const labelPrintProductParamsButton = () => (
    <Tooltip title="Parâmetros">
      <span
        className={`ml10 ${isPhoneScreen && 'mr15'} cursorPointer`}
        onClick={() => {
          setModalSettings(
            modalSettings.map((modal) =>
              modal.name === 'printParametersDialog'
                ? {
                    ...modal,
                    open: true
                  }
                : modal
            )
          );
        }}
      >
        <img
          style={{ width: '25px' }}
          src={isMobileScreen ? EngineIcon : EngineIconDesktop}
          alt="Parametros de Impressão"
        />
      </span>
    </Tooltip>
  );

  const openQrCodeCam = () => (
    <Tooltip title="Escanear QrCode" aria-label="add">
      <IconButton
        id="catalogProductScanQrCodeButton"
        className={`${isMobileScreen ? 'mr12' : 'mr20'} cursorPointer`}
        onClick={() => {
          setModalSettings(
            modalSettings.map((modal) =>
              modal.name === 'printQrCodeScannerDialog'
                ? { ...modal, open: true }
                : modal
            )
          );
        }}
        style={{ padding: 0, outline: 0 }}
      >
        <img style={{ width: '25px' }} src={QrCodeIcon} alt="QrCodeIcon" />
      </IconButton>
    </Tooltip>
  );

  const addProductButton = () => (
    <Tooltip title="Cadastrar novo produto" aria-label="add">
      <IconButton
        id="catalogProductAddButton"
        className="ml10 cursorPointer"
        onClick={() => {
          setModalSettings(
            modalSettings.map((modal) =>
              modal.name === 'productDialog' ? { ...modal, open: true } : modal
            )
          );
        }}
        style={{ padding: 0, outline: 0 }}
      >
        <img style={{ width: '25px' }} src={AddIcon} alt="AddIcon" />
      </IconButton>
    </Tooltip>
  );

  useEffect(() => {
    (async () => {
      const currentProduct = modalSettings.find(
        (modal) => modal.name === 'confirmDialog'
      )?.product;
      const groupActive =
        userInfo.companies.groups.length > 0
          ? userInfo.companies.groups.find((group) =>
              group.subGroups.some((subGroup) =>
                subGroup.stores.some(
                  (store) => store.id === userInfo.companiesActive.id
                )
              )
            )
          : {};
      const subGroupActive =
        userInfo.companies.groups.length > 0
          ? groupActive.subGroups.find((subGroup) =>
              subGroup.stores.some(
                (store) => store.id === userInfo.companiesActive.id
              )
            )
          : {};

      if (currentProduct) {
        const origins = await fetchRestaurantsOfProduct(currentProduct?.id);

        if (origins && origins.length > 0) {
          const { selectedSubGroups, selectedStores } = setSubGroupsAndStores({
            subGroups: groupActive.subGroups,
            originIds: origins
          });

          setRestaurantSubGroups(selectedSubGroups);
          setRestaurantStores(selectedStores);
        } else {
          setRestaurantSubGroups([subGroupActive]);
          setRestaurantStores(subGroupActive.stores);
        }
      } else {
        setRestaurantSubGroups([subGroupActive]);
        setRestaurantStores(subGroupActive.stores);
      }
    })();
  }, [
    userInfo.companiesActive,
    modalSettings.find((modal) => modal.name === 'confirmDialog')?.open,
    modalSettings.find(
      (modal) => modal.name === 'importSpreadSheetConfigDialog'
    )?.open
  ]);

  useEffect(() => {
    setUserGroups({ groups: userInfo.companies.groups });
  }, [userInfo]);

  useEffect(() => {
    setCallSettings((prevState) => ({ ...prevState, getId: paramsID }));
  }, [paramsID]);

  useEffect(() => {
    document.querySelector('main').scrollTo({ top: 0, behavior: 'smooth' });
  }, [callSettings.page]);

  useEffect(() => {
    if (productId) {
      setModalSettings((prev) =>
        prev.map((modal) =>
          modal.name === 'productDialog' ? { ...modal, open: true } : modal
        )
      );
    }
  }, [productId]);

  useEffect(() => {
    getMainContent(page, size);
    getValidityFilterContent();
  }, [labelsVersion, currentUserId, filtersChanged]);

  useEffect(() => {
    getValidityFilterContent();

    getOptions(
      `${environments.catalog}/flags`,
      'flags',
      flagOptions,
      setFlagOptions,
      currentUserId
    );
  }, [currentUserId]);

  useEffect(() => {
    (async () => {
      const currentId = isGroupManage ? getId?.split(',')[0] : getId;
      const response = await fetch(
        `${environments.restaurants}/companies/${currentId}/parameters`
      );
      const parametersResponse = await response.json();
      if (parametersResponse) {
        setParameters(parametersResponse);
      }
    })();
  }, [getId]);

  useEffect(() => {
    if (flags?.length && !originalFlags.length) {
      setOriginalFlags(flags);
    }
  }, [flags]);

  return (
    <Layout>
      <TitleHead title="Produtos" />
      <GlobalStyle />

      <Container>
        <PageTitleAndFilter
          title="Produtos"
          activeFilterFilds={filterFields}
          handleFilter={handleFilter}
          additionalbutton={
            (isLabelAdmin || labelManagerHasAllPermissions) && addProductButton
          }
          additionalButtonMobile={
            isLabelAdmin
              ? null
              : !isPhoneScreen &&
                isLabelManager &&
                labelPrintProductParamsButton
          }
          extrabutton={
            (isLabelAdmin || labelManagerHasAllPermissions) &&
            uploadSpreadsheetButton
          }
          extraButtonMobile={openQrCodeCam}
          getFilterhandle={getFilterhandle}
          supplementarybutton={
            isLabelAdmin || labelManagerHasAllPermissions
              ? () => (
                  <>
                    {downloadSpreadsheetButton()}
                    {exportSpreadsheetButton()}
                  </>
                )
              : null
          }
          complementarybutton={isLabelManager && labelPrintProductParamsButton}
          setFilterOpenedMainPageControl={setFilterOpen}
          filterFixedOnTop={true}
        />

        {!isLabelAdmin && (
          <ValidityFilter
            initialActive={prevLabelStatus ? [prevLabelStatus] : []}
            validityFilterInfos={validityFilterInfos}
            onClick={(value) => {
              handleFilter('labelStatus', value?.join(','));
            }}
            filterOpen={filterOpen}
          />
        )}

        <Snackbar
          open={toastOpen}
          autoHideDuration={6000}
          onClose={handleCloseToast}
        >
          <Alert onClose={handleCloseToast} severity={toastProps.severity}>
            {toastProps.message}
            {toastProps.lineErrors
              ? `\nLinha(s) com erro: ${toastProps.lineErrors}`
              : ''}
          </Alert>
        </Snackbar>

        {!isMobileScreen ? (
          <DesktopProductsTable
            mainLoading={mainLoading}
            products={products}
            getId={getId}
            setModalSettings={setModalSettings}
            modalSettings={modalSettings}
            isLabelAdmin={isLabelAdmin}
            labelManagerHasAllPermissions={labelManagerHasAllPermissions}
            isLabelUser={isLabelUser}
            setFlags={setFlags}
          />
        ) : (
          <MobileProductCards
            mainLoading={mainLoading}
            products={products}
            getId={currentUserId}
            setModalSettings={setModalSettings}
            modalSettings={modalSettings}
            handleFilter={handleFilter}
            isLabelAdmin={isLabelAdmin}
            labelManagerHasAllPermissions={labelManagerHasAllPermissions}
            isLabelUser={isLabelUser}
          />
        )}

        <InputFile
          type="file"
          id="spreadsheetImport"
          name="spreadsheetImport"
          onChange={(event) => uploadSpreadsheet(inputRef, event)}
          accept=".xlsx"
          ref={inputRef}
          aria-label="upload"
          style={{ display: 'none' }}
        />

        <PaginationWrapper className="pagination">
          <Pagination
            count={totalPages}
            onChange={(event, nextPage) => {
              if (event) {
                setCallSettings({ ...callSettings, page: nextPage });
                getMainContent(nextPage, size);
              }
            }}
            variant="outlined"
            shape="rounded"
            size="small"
            color="primary"
          />

          <ItemsPerPage
            numberOfElements={numberOfElements}
            size={totalElements}
          />
        </PaginationWrapper>

        {modalSettings.find((modal) => modal.name === 'confirmDeleteDialog')
          ?.open && (
          <ConfirmModal
            open={
              modalSettings.find(
                (modal) => modal.name === 'confirmDeleteDialog'
              )?.open
            }
            customClass={
              modalSettings.find(
                (modal) => modal.name === 'confirmDeleteDialog'
              )?.customClass
            }
            title={
              modalSettings.find(
                (modal) => modal.name === 'confirmDeleteDialog'
              )?.title
            }
            content={
              <div className="dFlex pt16">
                <Autocomplete
                  options={allowedFlagOptions}
                  getOptionLabel={(option) => option?.description}
                  className={`autocompleteSmall w100 ${
                    invalidFields?.flags && 'labelError'
                  }`}
                  onFocus={() => {
                    if (!flagOptions?.length) {
                      getOptions(
                        `${environments.catalog}/flags`,
                        'flags',
                        flagOptions,
                        setFlagOptions,
                        currentUserId
                      );
                    }
                  }}
                  multiple
                  size="small"
                  limitTags={2}
                  value={flagOptions.filter((option) =>
                    flags?.map((flag) => flag?.id)?.includes(option.id)
                  )}
                  onChange={(_event, value) => {
                    setFlags(value);
                  }}
                  getOptionDisabled={(option) => {
                    return flags?.some(
                      (item) =>
                        (item?.id || item?._id) === (option?.id || option?._id)
                    );
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      id={params.id}
                      type="text"
                      name="flags"
                      label="Marcas"
                      variant="outlined"
                      required
                      placeholder="Selecione..."
                      InputLabelProps={{
                        shrink: true
                      }}
                    />
                  )}
                  renderOption={(params) => (
                    <Typography
                      style={{
                        fontSize: '12px',
                        fontFamily: 'Lato'
                      }}
                    >
                      {params.description}
                    </Typography>
                  )}
                />
              </div>
            }
            onConfirm={() => {
              handleDelete(
                modalSettings.find(
                  (modal) => modal.name === 'confirmDeleteDialog'
                )?.product
              );
            }}
            onClose={() => {
              setFlags();
              setOriginalFlags([]);

              modalSettings
                .find((modal) => modal.name === 'confirmDeleteDialog')
                ?.onClose?.();
            }}
            cancelText="Não"
            confirmText="Sim"
            disableSubmitButton={!flags?.length}
          />
        )}

        {modalSettings.find(
          (modal) => modal.name === 'importSpreadSheetConfigDialog'
        )?.open && (
          <ConfirmModal
            open={
              modalSettings.find(
                (modal) => modal.name === 'importSpreadSheetConfigDialog'
              )?.open
            }
            customClass={
              modalSettings.find(
                (modal) => modal.name === 'importSpreadSheetConfigDialog'
              )?.customClass
            }
            title={
              modalSettings.find(
                (modal) => modal.name === 'importSpreadSheetConfigDialog'
              )?.title
            }
            content={
              <div className="dFlex pt16">
                <Autocomplete
                  options={flagOptions}
                  getOptionLabel={(option) => option?.description}
                  className={`autocompleteSmall w100 ${
                    invalidFields?.flags && 'labelError'
                  }`}
                  onFocus={() =>
                    getOptions(
                      `${environments.catalog}/flags`,
                      'flags',
                      flagOptions,
                      setFlagOptions,
                      currentUserId
                    )
                  }
                  multiple
                  size="small"
                  limitTags={2}
                  value={flags}
                  onChange={(_event, value) => {
                    setFlags(value);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      id={params.id}
                      type="text"
                      name="flags"
                      label="Marcas"
                      variant="outlined"
                      required
                      placeholder="Selecione..."
                      InputLabelProps={{
                        shrink: true
                      }}
                    />
                  )}
                  renderOption={(params) => (
                    <Typography
                      style={{
                        fontSize: '12px',
                        fontFamily: 'Lato'
                      }}
                    >
                      {params.description}
                    </Typography>
                  )}
                />
              </div>
            }
            onConfirm={() => {
              modalSettings
                .find((modal) => modal.name === 'importSpreadSheetConfigDialog')
                ?.onClose?.();
              document.getElementById('spreadsheetImport').click();
            }}
            onClose={() => {
              setFlags([]);
              modalSettings
                .find((modal) => modal.name === 'importSpreadSheetConfigDialog')
                ?.onClose?.();
            }}
            cancelText="Cancelar"
            confirmText="Importar"
            disableSubmitButton={!flags?.length}
          />
        )}

        {modalSettings.find((modal) => modal.name === 'confirmDialog')
          ?.open && (
          <ConfirmModal
            open={
              modalSettings.find((modal) => modal.name === 'confirmDialog')
                ?.open
            }
            title={
              modalSettings.find((modal) => modal.name === 'confirmDialog')
                ?.title
            }
            content={
              <Typography className="bold">
                {
                  modalSettings.find((modal) => modal.name === 'confirmDialog')
                    ?.content
                }
              </Typography>
            }
            onConfirm={
              modalSettings.find((modal) => modal.name === 'confirmDialog')
                ?.onConfirm
            }
            onClose={() =>
              modalSettings
                .find((modal) => modal.name === 'confirmDialog')
                ?.onClose?.()
            }
            cancelText="Não"
            confirmText="Sim"
          />
        )}

        {modalSettings.find((modal) => modal.name === 'productDialog').open && (
          <ProductDialog
            open={
              modalSettings.find((modal) => modal.name === 'productDialog').open
            }
            onClose={() => {
              setModalSettings(
                modalSettings.map((modal) =>
                  modal.name === 'productDialog'
                    ? { ...modal, open: false }
                    : modal
                )
              );

              history.push(`/etiquetas/catalogo/produtos/${paramsID}`);
            }}
            onlyView={
              isLabelUser || (!labelManagerHasAllPermissions && !isLabelAdmin)
            }
            onSuccess={() => {
              getMainContent(page, size, true);
            }}
          />
        )}

        {modalSettings.find((modal) => modal.name === 'stockExtractDialog')
          .open && (
          <StockExtractDialog
            open={
              modalSettings.find((modal) => modal.name === 'stockExtractDialog')
                .open
            }
            onClose={() => {
              setModalSettings(
                modalSettings.map((modal) =>
                  modal.name === 'stockExtractDialog'
                    ? { ...modal, open: false }
                    : modal
                )
              );
              history.push(`/etiquetas/catalogo/produtos/${paramsID}`);
            }}
            initialProduct={
              modalSettings.find((modal) => modal.name === 'stockExtractDialog')
                .initialProduct || null
            }
            onSuccess={() => {
              getMainContent(page, size, true);
              getValidityFilterContent();
            }}
            printLabel={(product) => {
              printLabel(product, true);
            }}
            setModalSettings={setModalSettings}
          />
        )}

        {modalSettings.find((modal) => modal.name === 'printParametersDialog')
          .open && (
          <PrintParametersDialog
            open={
              modalSettings.find(
                (modal) => modal.name === 'printParametersDialog'
              ).open
            }
            onClose={() => {
              setModalSettings(
                modalSettings.map((modal) =>
                  modal.name === 'printParametersDialog'
                    ? { ...modal, open: false }
                    : modal
                )
              );
              // history.push(`/etiquetas/catalogo/produtos/${paramsID}`);
            }}
            manufactures={parameters?.manufactures || null}
            onSuccess={() => {
              getMainContent(page, size);
            }}
          />
        )}

        {modalSettings.find((modal) => modal.name === 'labelPrintConfigDialog')
          ?.open && (
          <LabelPrintConfigDialog
            open={
              modalSettings.find(
                (modal) => modal.name === 'labelPrintConfigDialog'
              )?.open
            }
            onClose={() => {
              setModalSettings(
                modalSettings.map((modal) =>
                  modal.name === 'labelPrintConfigDialog'
                    ? { ...modal, open: false, product: null }
                    : modal
                )
              );
            }}
            onSubmit={(product, isReprint) => {
              printLabel(product, isReprint);
            }}
            selectedProduct={
              modalSettings.find(
                (modal) => modal.name === 'labelPrintConfigDialog'
              )?.product
            }
            userInfo={userInfo}
            updateMainList={() => {
              getMainContent(page, size);
            }}
          />
        )}

        {modalSettings.find(
          (modal) => modal.name === 'printQrCodeScannerDialog'
        )?.open && (
          <PrintQrCodeScannerDialog
            open={
              modalSettings.find(
                (modal) => modal.name === 'printQrCodeScannerDialog'
              )?.open
            }
            onClose={() => {
              setModalSettings(
                modalSettings.map((modal) =>
                  modal.name === 'printQrCodeScannerDialog'
                    ? { ...modal, open: false, product: null }
                    : modal
                )
              );
            }}
            onDetected={async (productId) => {
              try {
                const response = await axios.get(
                  `${environments.catalog}/printer/products/${productId}`,
                  {
                    params: { restaurantId: currentUserId }
                  }
                );

                const data = response.data;

                setModalSettings((prev) =>
                  prev.map((modal) => {
                    if (modal.name === 'printQrCodeScannerDialog') {
                      return { ...modal, open: false, product: null };
                    }

                    if (modal.name === 'labelPrintConfigDialog') {
                      return { ...modal, open: true, product: data };
                    }

                    return modal;
                  })
                );
              } catch (error) {
                setMessage({
                  description: 'Erro ao buscar produto',
                  status: 'error'
                });
              }
            }}
          />
        )}
      </Container>

      <CommonAlert
        open={message?.description}
        onClose={() => setMessage({ description: '', status: '' })}
        severity={message?.status}
        indexMessage={message?.description}
        messagePersonal={message?.description}
      />

      <OverlayLabelPrintFooter />
    </Layout>
  );
}

const mapStateToProps = (state) => ({
  userInfo: state.user
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(ProductsActions, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Products);
